export default __webpack_public_path__ + "static/media/list.db54c429.svg";